import * as React from 'react';
import { SvgProps, Svg, G, Path, Circle } from 'react-native-svg';

export const SvgUsersRound = ({ strokePath, ...props }: SvgProps) => {
  return (
    <Svg
      width={'100%'}
      height={'100%'}
      viewBox="0 0 24 24"
      fill="none"
      stroke="#fff"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}>
      <Path stroke={strokePath || props.color} d="M18 21a8 8 0 0 0-16 0" />
      <Circle stroke={strokePath || props.color} cx={10} cy={8} r={5} />
      <Path stroke={strokePath || props.color} d="M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3" />
    </Svg>
  );
}
